import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { Walkout } from '../types';
import { CreateWalkoutRequest, WalkoutResponse } from '../types/transaction';

@Injectable({
  providedIn: 'root',
})
export class WalkoutService {
  apiHost = `${environment.apiBaseUrl}`;

  private httpClient = inject(HttpClient);

  getAvailableWalkouts(locationId: number) {
    const requestUrl = `${this.apiHost}/Walkout/AvailableWalkouts/${locationId}`;
    return this.httpClient.get<Walkout[]>(requestUrl);
  }

  createWalkout(request: CreateWalkoutRequest) {
    const requestUrl = `${this.apiHost}/Walkout`;
    return this.httpClient.post<WalkoutResponse>(requestUrl, request);
  }
}
